<template>
  <div>
    <label for="bookingPrivilegeSelected"
      >Privilege<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingPrivilegeSelected"
      v-model="privilege"
      :options="privileges"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingPrivilegeDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    brandCode: { type: String, default: null },
    serviceId: { type: Number, default: null },
  },
  data() {
    return {
      privilege: this.value,
      privileges: [],
    };
  },
  created() {
    if (this.brandCode && this.serviceId) {
      this.getPrivileges(this.brandCode, this.serviceId);
    }
  },
  watch: {
    privilege(newValue) {
      this.$emit("setPrivilege", newValue);
    },
    value(newValue) {
      this.privilege = newValue;
    },
    privileges(newValue) {
      this.$emit("setPrivileges", newValue);
    },
    brandCode(newBrandCode) {
      if (newBrandCode && this.serviceId) {
        this.getPrivileges(newBrandCode, this.serviceId);
      } else {
        this.clearPrivileges();
      }
    },
    serviceId(newServiceId) {
      if (newServiceId && this.brandCode) {
        this.getPrivileges(this.brandCode, newServiceId);
      } else {
        this.clearPrivileges();
      }
    },
  },
  methods: {
    async getPrivileges(brandCode, serviceId) {
      try {
        emitLoadingStart(this);
        await BookingService.getPrivileges({
          brandCode: brandCode,
          serviceId: serviceId,
        })
          .then(async (res) => {
            const data = await res.data;
            this.privileges = data.items
              .map((s) => {
                return {
                  id: s.key,
                  text: s.value,
                  detail: s.detail,
                };
              })
              .sort(function (a, b) {
                return a.text.localeCompare(b.text);
              });
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
    clearPrivileges() {
      this.privileges = [];
    },
  },
};
</script>
